import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './aap/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker';
import { createDb } from './offlineManager/localbase';
import { persistStore } from 'redux-persist'
import { ErrorBoundary } from 'react-error-boundary';
import { logError } from './utils/utils';
import ErrorFallback from './errorFallback';

persistStore(store, {}, () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>

        <ErrorBoundary onError={logError} FallbackComponent={ErrorFallback}>
          <App />
        </ErrorBoundary>

      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
})


// ReactDOM.render(
//   <Provider store={store}>
//   <App />
// </Provider>,
//   document.getElementById('root')
// );


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
serviceWorker.register();
setTimeout(() => {
  createDb();
});
